import React from "react";
import LegalLayout from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      title="Termini di Servizio"
      sub="Termini e condizioni"
      render={(lang) => (lang === "it" ? <ItContent /> : <EnContent />)}
    />
  );
}

function ItContent() {
  return (
    <>
      <p>
        I presenti Termini di Servizio ("Termini") regolano l'utilizzo di Reelio, servizio fornito da Marco Marangoni — P.IVA 04018220964, Piazza della Costituzione 12, 20068 Peschiera Borromeo (MI). Utilizzando il Servizio accetti integralmente questi Termini.
      </p>

      <h2>1. Definizioni</h2>
      <ul>
        <li><strong>Servizio:</strong> la piattaforma Reelio accessibile su reelio.it per la generazione di reel video e caroselli social tramite AI.</li>
        <li><strong>Utente:</strong> persona fisica o giuridica registrata al Servizio.</li>
        <li><strong>Contenuto Utente:</strong> testi, immagini, audio caricati o generati dall'Utente tramite il Servizio.</li>
      </ul>

      <h2>2. Account e accesso</h2>
      <ul>
        <li>L'iscrizione è gratuita; alcune funzionalità sono riservate ai piani a pagamento (Pro, Agency).</li>
        <li>L'Utente garantisce la veridicità dei dati forniti e si impegna a mantenerli aggiornati.</li>
        <li>L'Utente è responsabile della custodia delle credenziali di accesso e di ogni attività svolta tramite il proprio account.</li>
        <li>L'età minima per registrarsi è 16 anni (art. 8 GDPR).</li>
      </ul>

      <h2>3. Piani e pagamenti</h2>
      <ul>
        <li>I piani a pagamento sono mensili e si rinnovano automaticamente fino a disdetta.</li>
        <li>I pagamenti sono gestiti tramite Stripe. Le carte di credito non transitano mai sui server di Reelio.</li>
        <li>L'Utente può cancellare l'abbonamento in qualsiasi momento dalla propria area personale; l'accesso resta attivo fino alla scadenza del periodo pagato.</li>
        <li><strong>Rimborsi:</strong> ai sensi dell'art. 59, lett. m, del Codice del Consumo, il Servizio è qualificabile come "contenuto digitale fornito su supporto non materiale" — l'esercizio del Servizio comporta la rinuncia al diritto di recesso. I rimborsi sono valutati caso per caso (es. addebito errato).</li>
      </ul>

      <h2>4. Contenuti generati dall'AI</h2>
      <ul>
        <li>I testi, le immagini e gli audio prodotti dal Servizio sono generati tramite modelli di intelligenza artificiale di terze parti (OpenAI, Anthropic, Google). <strong>Reelio non garantisce</strong> l'accuratezza, l'originalità o l'assenza di errori dei contenuti generati.</li>
        <li>L'Utente è tenuto a verificare i contenuti prima di pubblicarli o utilizzarli commercialmente, anche al fine di evitare violazioni di diritti d'autore, di marchio o di terzi.</li>
        <li>Reelio non si assume responsabilità per i contenuti pubblicati dall'Utente su piattaforme social di terze parti (Instagram, TikTok, ecc.).</li>
        <li>Ai sensi dell'AI Act (Reg. UE 2024/1689), l'Utente si impegna a dichiarare apertamente quando un contenuto è stato generato o significativamente modificato tramite intelligenza artificiale (deepfake, manipolazione di immagini di persone reali, ecc.).</li>
      </ul>

      <h2>5. Diritti di proprietà intellettuale</h2>
      <ul>
        <li><strong>Contenuti dell'Utente:</strong> l'Utente mantiene tutti i diritti sui propri contenuti caricati. Concede a Reelio una licenza non esclusiva, gratuita e revocabile, limitata a quanto necessario per fornire il Servizio (es. archiviare, processare, mostrare i contenuti).</li>
        <li><strong>Output AI:</strong> ai contenuti generati dall'AI si applicano i termini d'uso dei rispettivi fornitori (OpenAI, Anthropic, Google). L'Utente ne acquisisce i diritti d'uso commerciale nei limiti consentiti da tali fornitori.</li>
        <li><strong>Software Reelio:</strong> il codice, il design, il logo e il marchio Reelio sono di proprietà del Titolare. È vietato copiare, decompilare o redistribuire senza autorizzazione scritta.</li>
      </ul>

      <h2>6. Utilizzi vietati</h2>
      <p>L'Utente si impegna a NON utilizzare il Servizio per:</p>
      <ul>
        <li>Generare contenuti illegali, diffamatori, discriminatori, violenti, sessualmente espliciti o lesivi di minori.</li>
        <li>Violare diritti di proprietà intellettuale, marchi, ritratti di terzi senza consenso.</li>
        <li>Generare deepfake con scopi fraudolenti, di phishing, manipolazione politica o lesione della reputazione altrui.</li>
        <li>Inviare spam, malware o effettuare azioni di scraping/reverse engineering del Servizio.</li>
        <li>Vendere, rivendere o sub-licenziare l'accesso al Servizio senza piano Agency.</li>
      </ul>
      <p>La violazione di queste clausole comporta la sospensione o cancellazione dell'account senza preavviso e senza diritto a rimborso.</p>

      <h2>7. Programma referral</h2>
      <ul>
        <li>Ogni Utente registrato riceve un codice referral univoco.</li>
        <li>L'Utente che invita ("Referrer") riceve un cashback pari al 50% del primo pagamento effettuato dal nuovo iscritto ("Referee"), accreditato sul saldo dell'account.</li>
        <li>Il Referee riceve 30 giorni gratuiti del piano Pro al momento della registrazione con codice valido.</li>
        <li>Cap annuale: il cashback complessivo per Referrer è limitato a € 4.500 / anno solare per garantire la qualificazione come prestazione occasionale ai sensi della normativa fiscale italiana.</li>
        <li>I prelievi del cashback richiedono il completamento dell'onboarding KYC tramite Stripe Connect (in arrivo).</li>
        <li>Reelio si riserva il diritto di annullare cashback derivanti da iscrizioni fraudolente, auto-referral o violazione dei Termini.</li>
      </ul>

      <h2>8. Limitazione di responsabilità</h2>
      <p>
        Nei limiti consentiti dalla legge applicabile, Reelio non è responsabile per danni indiretti, perdite di profitto, perdite di dati, interruzioni dell'attività dell'Utente derivanti dall'uso o impossibilità di utilizzare il Servizio. La responsabilità complessiva del Titolare verso l'Utente non potrà comunque superare l'importo pagato dall'Utente nei 12 mesi precedenti il fatto generatore del danno.
      </p>
      <p>Il Servizio è fornito "così com'è" senza garanzie di disponibilità continua o assenza di errori. Reelio si impegna comunque a garantire un livello di servizio ragionevolmente affidabile (target 99% uptime mensile).</p>

      <h2>9. Sospensione e cessazione</h2>
      <ul>
        <li>L'Utente può cancellare il proprio account in qualsiasi momento. La cancellazione comporta l'eliminazione dei dati entro 30 giorni (vedi <a href="/privacy">Privacy Policy</a>).</li>
        <li>Reelio può sospendere l'account in caso di violazione dei Termini, mancato pagamento o uso fraudolento del Servizio.</li>
      </ul>

      <h2>10. Modifiche ai Termini</h2>
      <p>Reelio può modificare i presenti Termini. Le modifiche saranno comunicate via email con preavviso di 30 giorni. La prosecuzione dell'utilizzo del Servizio dopo tale termine comporta accettazione delle modifiche.</p>

      <h2>11. Legge applicabile e foro competente</h2>
      <p>I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia il foro competente è quello del consumatore (ai sensi dell'art. 66-bis Codice del Consumo) o, in mancanza, il Foro di Milano.</p>

      <h2>12. Contatti</h2>
      <p>Per qualsiasi domanda relativa ai presenti Termini: <a href="mailto:info@homereel.it">info@homereel.it</a></p>
    </>
  );
}

function EnContent() {
  return (
    <>
      <p>
        These Terms of Service ("Terms") govern the use of Reelio, a service provided by Marco Marangoni — VAT 04018220964, Piazza della Costituzione 12, 20068 Peschiera Borromeo (MI), Italy. By using the Service you accept these Terms in full.
      </p>

      <h2>1. Definitions</h2>
      <ul>
        <li><strong>Service:</strong> the Reelio platform at reelio.it.</li>
        <li><strong>User:</strong> any natural or legal person registered to the Service.</li>
        <li><strong>User Content:</strong> texts, images, audio uploaded or generated by the User.</li>
      </ul>

      <h2>2. Account</h2>
      <ul>
        <li>Registration is free; advanced features require paid plans (Pro, Agency).</li>
        <li>The User warrants the truthfulness of data provided.</li>
        <li>The User is responsible for safeguarding credentials.</li>
        <li>Minimum age: 16 (Art. 8 GDPR).</li>
      </ul>

      <h2>3. Plans and payments</h2>
      <ul>
        <li>Paid plans renew monthly until cancellation.</li>
        <li>Payments are processed via Stripe.</li>
        <li>Cancellation is available at any time; access remains until end of paid period.</li>
        <li><strong>Refunds:</strong> per Article 59(m) of the Italian Consumer Code, this is a digital service: starting use waives withdrawal rights. Refunds are reviewed case by case.</li>
      </ul>

      <h2>4. AI-generated content</h2>
      <ul>
        <li>Texts, images and audio produced by the Service are generated by third-party AI models (OpenAI, Anthropic, Google). Reelio does not warrant accuracy, originality, or freedom from errors.</li>
        <li>The User must verify content before publishing or commercial use.</li>
        <li>Reelio is not responsible for content the User publishes on third-party social platforms.</li>
        <li>Under the EU AI Act (Reg. 2024/1689), the User must clearly disclose AI-generated or manipulated content (deepfakes etc.).</li>
      </ul>

      <h2>5. Intellectual property</h2>
      <ul>
        <li><strong>User Content:</strong> ownership retained by User; non-exclusive license granted to Reelio to deliver the Service.</li>
        <li><strong>AI Output:</strong> subject to upstream vendors' terms.</li>
        <li><strong>Reelio software, design, brand:</strong> owned by the Controller; no copying, decompiling or redistribution allowed.</li>
      </ul>

      <h2>6. Prohibited uses</h2>
      <p>The User shall NOT use the Service to generate illegal, defamatory, discriminatory, violent or sexually explicit content; infringe third-party rights; create fraudulent deepfakes; send spam/malware; scrape or reverse-engineer the Service; resell access without an Agency plan.</p>

      <h2>7. Referral program</h2>
      <ul>
        <li>Each User receives a unique referral code.</li>
        <li>Referrer cashback: 50% one-shot on referee's first paid invoice.</li>
        <li>Referee: 30 free days of Pro on registration with a valid code.</li>
        <li>Annual cap: € 4,500 per Referrer per calendar year.</li>
        <li>Cashback withdrawal requires Stripe Connect KYC onboarding.</li>
        <li>Reelio may void cashback derived from fraudulent or self-referral activity.</li>
      </ul>

      <h2>8. Limitation of liability</h2>
      <p>To the extent permitted by law, Reelio is not liable for indirect damages or loss of profit. Total liability shall not exceed the amount paid by the User in the 12 months preceding the event. The Service is provided "as is" with a target of 99% monthly uptime.</p>

      <h2>9. Suspension and termination</h2>
      <p>The User may delete their account anytime. Reelio may suspend accounts in case of breach, non-payment, or fraudulent use.</p>

      <h2>10. Changes</h2>
      <p>Reelio may amend these Terms with 30-day notice via email.</p>

      <h2>11. Governing law and jurisdiction</h2>
      <p>These Terms are governed by Italian law. Disputes fall under the consumer's court (Art. 66-bis Italian Consumer Code) or, alternatively, the Court of Milan.</p>

      <h2>12. Contact</h2>
      <p><a href="mailto:info@homereel.it">info@homereel.it</a></p>
    </>
  );
}
